<template>
	<section ref="qrPanel" class="qr-section">
		<div class="widget-wrapper">
			<div id="widgetContainer"></div>
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n();

const initWidget = () => {
	if (!window.BV) {
		return;
	}

	const container = document.getElementById('widgetContainer');
	if (container) {
		container.innerHTML = '';
	}

	const config: BookVisitConfig = {
		channelId: '469c2dd2-3c58-4f0f-8a01-9ca007b77cd3',
		widgetLayout: 'Standard2Columns',
		WidgetContainerId: 'widgetContainer',
		promoCode: false,
		corpCode: false,
		agentCode: false,
		loginLink: false,
		accommodationTypePicker: false,
		type: 'single_property',
		languageCulture: locale.value,
	};

	window.BV.SPWidget(config);
};

let scriptLoaded = false;
const loadScript = () => {
	if (scriptLoaded) {
		initWidget();

		return;
	}

	const script = document.createElement('script');
	script.src = 'https://reservations.bookvisit.com/widget?type=accommodation';
	script.async = true;
	script.onload = () => {
		scriptLoaded = true;
		initWidget();
	};

	document.head.appendChild(script);
};

onMounted(() => {
	loadScript();
});

watch(locale, () => {
	initWidget();
});
</script>

<style lang="scss">
.widget-wrapper {
	background: #fff;
	padding: 20px;
}

.mx-btn:hover {
	color: var(--cta-color-hover) !important;
}

.mx-table-date .today {
	color: var(--cta-color-hover) !important;
}

.mx-calendar-content .cell.disabled {
	color: #ccc !important;
}

.mx-calendar-content .cell:hover {
	color: var(--cta-color) !important;
	background-color: #fef3f3 !important;
}

.mx-calendar-content .cell.active {
	color: #fff !important;
	background-color: var(--cta-color-hover) !important;
}
</style>

<style lang="scss" scoped>
.mx-datepicker {
	min-width: 235px;
}

:deep(.mx-icon-calendar) {
	right: 15px;
	color: #000;
}

.qr-section {
	margin: 0 auto;
	position: absolute;
	bottom: 110px;
	left: 0;
	right: 0;
	padding: 0;
	max-width: 840px;
	z-index: 10;

	.qr-panel {
		padding: 23px 20px;
		background: url('~/assets/images/qr-panel-bg-image.png') no-repeat center center;
		background-size: cover;
		border: 1px solid #fff;
		text-align: center;

		form {
			display: flex;
			gap: 15px;

			input,
			select,
			:deep(.mx-input) {
				font-size: 15px;
				font-family: var(--body-font-family);
				height: auto;
				padding: 20px 32px;
				border: none;
				border-radius: 0;
			}

			.button {
				flex-grow: 1;
			}
		}
	}
}

@media (max-width: 880px) {
	.qr-section {
		display: none;
	}
}
</style>
